import dayjs from '@/services/date'
import sanitizeHtml from '@/utils/sanitize-html'
import DateFormatTokens from '@/constants/date/DateFormatToken'

export default class ScheduleExceptionUpdateDTO {
  constructor({ id, title, dateLocal }) {
    this.id = id ?? -1
    this.title = sanitizeHtml(title)
    this.startTimeLocal = _setTime(dateLocal, 'start')
    this.endTimeLocal = _setTime(dateLocal, 'end')
  }

  get isValid() {
    return (
      this.title.trim().length > 0 &&
      dayjs(this.startTimeLocal).isValid() &&
      dayjs(this.endTimeLocal).isValid()
    )
  }
}

function _setTime(dateLocal, type = 'start') {
  const timeConfig = {
    start: { hour: 0, minute: 0, second: 0 },
    end: { hour: 23, minute: 59, second: 59 },
  }

  const config = timeConfig[type]

  return dayjs(dateLocal)
    .set('hour', config.hour)
    .set('minute', config.minute)
    .set('second', config.second)
    .format(DateFormatTokens.YYYYMMDDTHHmmss)
}
